export enum PlanBillingType {
  UNSET_BILLING_TYPE = 'UNSET_BILLING_TYPE', // Do not use, needed because of proto3 limitations
  PRE_PAID = 'PRE_PAID',
  POST_PAID = 'POST_PAID',
}
